import React, { useState } from 'react'
import { Box, TextField } from '@material-ui/core'
import { Button } from "../../../../shared/ui/button"
import { useLogic } from '../../../../../hooks/storeHook'
import { CategoryAttributeModel } from '../../../../../server/mpsklad_core/Models/MpCard/CategoryAttributeModel'
import { ProductCardVariantUpdateModel } from '../../../../../server/mpsklad_core/Models/MpCard/ProductCardVariantUpdateModel'

type NewVariantType = {
  vendorCode: string
  title: string
  price: number
  basePrice: number
  attributes: Array<{ id: string; currentValue: string; unit?: string }>
}

type VariantsEditorWbProps = {
  editableAttributes: CategoryAttributeModel[]
  parentCardIdProp?: string
}

export const VariantsEditorWb: React.FC<VariantsEditorWbProps> = ({ editableAttributes, parentCardIdProp }) => {
  const [variants, setVariants] = useState<NewVariantType[]>([])
  const logic = useLogic()

  const addVariant = () => {
    setVariants(prev => [
      ...prev,
      {
        vendorCode: '',
        title: '',
        price: 0,
        basePrice: 0,
        attributes: editableAttributes.map(a => ({ id: a.id, currentValue: '', unit: a.unit }))
      }
    ])
  }

  const updateVariant = <K extends keyof NewVariantType>(
    index: number,
    field: K,
    value: NewVariantType[K] // вместо any используем тип значения из NewVariantType
  ) => {
    setVariants(prev => {
      const newArr = [...prev]
      newArr[index] = { ...newArr[index], [field]: value }
      return newArr
    })
  }

  const updateAttribute = (variantIndex: number, attrIndex: number, value: string) => {
    setVariants(prev => {
      const newArr = [...prev]
      newArr[variantIndex].attributes[attrIndex].currentValue = value
      return newArr
    })
  }

  const mapVariantToApiModel = (variant: NewVariantType): ProductCardVariantUpdateModel => {
    if (!parentCardIdProp) throw new Error('Parent card ID is missing')
    return {
      parentCardId: parentCardIdProp,
      vendorCode: variant.vendorCode,
      title: variant.title,
      description: undefined,
      brand: undefined,
      attributes: variant.attributes.map(a => ({
        categoryAttributeId: a.id,
        value: a.currentValue,
        unit: a.unit ?? ''
      })),
      images: []
    }
  }


  const saveVariant = async (index: number) => {
    try {
      if (!parentCardIdProp) throw new Error('Parent card ID is missing')
      const apiModel = mapVariantToApiModel(variants[index])
      const message = await logic.api.mpCard.saveCardVariant(apiModel)
      console.log(message)
      alert('Вариант успешно сохранен')
    } catch (e) {
      console.error(e)
      alert('Ошибка при сохранении варианта')
    }
  }

  const removeVariant = (index: number) => {
    setVariants(prev => prev.filter((_, i) => i !== index))
  }

  return (
    <Box mt={2}>
      {variants.map((variant, index) => (
        <Box key={index} mb={2} p={2} border="1px solid #ccc">
          <TextField
            label="Vendor Code"
            value={variant.vendorCode}
            onChange={e => updateVariant(index, 'vendorCode', e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
            margin="dense"
          />
          <TextField
            label="Название"
            value={variant.title}
            onChange={e => updateVariant(index, 'title', e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
            margin="dense"
          />
          <TextField
            label="Цена"
            type="number"
            value={variant.price}
            onChange={e => updateVariant(index, 'price', Number(e.target.value))}
            variant="outlined"
            size="small"
            fullWidth
            margin="dense"
          />
          <TextField
            label="Базовая цена"
            type="number"
            value={variant.basePrice}
            onChange={e => updateVariant(index, 'basePrice', Number(e.target.value))}
            variant="outlined"
            size="small"
            fullWidth
            margin="dense"
          />

          {variant.attributes.map((attr, attrIndex) => (
            <TextField
              key={attr.id}
              label={editableAttributes.find(a => a.id === attr.id)?.name || 'Атрибут'}
              value={attr.currentValue}
              onChange={e => updateAttribute(index, attrIndex, e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
            />
          ))}

          <Box display="flex" mt={1}>
            <Button type="button" onClick={() => saveVariant(index)} style={{ marginRight: 8 }}>
              Сохранить вариант
            </Button>
            <Button type="button" onClick={() => removeVariant(index)}>
              Удалить вариант
            </Button>
          </Box>
        </Box>
      ))}

      <Button type="button" onClick={addVariant} style={{ marginTop: 8 }}>
        Добавить новый вариант
      </Button>
    </Box>
  )
}
